<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar class="mb-2 pa-0" color="primary" dark flat>
          <v-toolbar-title>{{ grafTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="3">
        <v-autocomplete
          label="Lokalita"
          v-model="filterLokalitaId"
          :items="lokality"
          item-text="Name"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          label="Bod"
          v-model="filterBodId"
          :items="body"
          item-text="ZNMB"
          item-value="ID"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="end">
      <v-col cols="12">
        <v-range-slider
          label="Výber obdobia"
          v-model="filterORange"
          step="1"
          :min="1990"
          :max="new Date().getFullYear()"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
    </v-row>

    <v-row v-if="loading1">
      <v-col cols="12">
        <div class="text-center" style="width: 100%">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
        ></line-chart>
      </v-col>
    </v-row>
    <v-row align="end">
      <v-col cols="8">
        <v-range-slider
          label="Výber referenčného obdobia"
          v-model="filterRORange"
          step="1"
          :min="1990"
          :max="new Date().getFullYear()"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
      <v-col cols="2">
        <v-select
          :items="chartYears"
          label="Rok"
          v-model="filterRok"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="loading2">
      <v-col cols="12">
        <div class="text-center" style="width: 100%">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
        ></line-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "../plugins/miscella.js"
import LineChart from "../components/charts/BarChart.js"

export default {
  data: function() {
    return {
      loading1: false,
      loading2: false,
      filterLokalitaId: "",
      filterBodId: "",
      filterRok: 0,
      filterORange: [1990, new Date().getFullYear()],
      filterRORange: [1990, new Date().getFullYear()],
      grafData1: [],
      grafData2: [],
      lokality: [],
      body: []
    }
  },
  components: { LineChart },
  props: {},
  computed: {
    grafTitle: function() {
      return "Grafy - Hladiny podzemnej vody"
    },
    chartYears: function() {
      let arr = []
      for (let i = 1990; i < new Date().getFullYear() + 1; i++) {
        arr.push(i)
      }
      return arr
    }
  },
  watch: {
    filterLokalitaId: {
      immediate: true,
      handler: function() {
        console.log("filterLokalitaId changed, fetching body...")
        this.filterBodId = ""
        this.readBody()
      }
    },
    filterBodId: function() {
      if (this.filterBodId !== "") {
        this.show(1)
        this.show(2)
      }
    },
    filterRok: function() {
      if (this.filterBodId !== "") {
        this.show(1)
        this.show(2)
      }
    },
    filterORange: function() {
      if (this.filterBodId !== "") {
        Miscella.myDelay(() => {
          this.show(1)
        }, 1000)
      }
    },
    filterRORange: function() {
      if (this.filterBodId !== "") {
        Miscella.myDelay(() => {
          this.show(2)
        }, 1000)
      }
    }
  },
  methods: {
    readLokality: async function() {
      try {
        this.lokality = []
        let response = await this.$axios.get(`/r/lokality/mer_hpv`)
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBody: async function() {
      try {
        this.body = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_hpv"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.body = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    grafValues: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 1:
          ret = {
            labels: this.grafData1.map(i => i.Datum),
            //labels: ["January", "February", "March", "April"],
            datasets: [
              {
                label: "Kolísanie hĺbky podzemnej vody",
                data: this.grafData1.map(i => i.Hladina),
                backgroundColor: "#00bfff",
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "false",
                type: "line",
                yAxisID: "y-axis-hladina"
              },
              {
                label: "Teplota podzemnej vody",
                data: this.grafData1.map(i => i.Teplota),
                backgroundColor: "#935d5d",
                borderColor: "#935d5d",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "false",
                type: "line",
                yAxisID: "y-axis-teplota"
              }
            ]
          }
          break
        case 2:
          ret = {
            labels: this.grafData2.map(i => i.Datum),
            datasets: [
              {
                label: "Kolísanie hĺbky hladiny podzemnej vody",
                data: this.grafData2.map(i => i.Hladina),
                backgroundColor: "#00bfff",
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "false",
                type: "line"
              },
              {
                label: `Q0 - nultý kvartil (minimálny stav hladiny počas obdobia (${this.filterRORange[0]} - ${this.filterRORange[1]})`,
                data: this.grafData2.map(i => i.Kvartil0),
                backgroundColor: "#009966",
                borderColor: "#009966",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              },
              {
                label: "Q1 - prvý kvartil",
                data: this.grafData2.map(i => i.Kvartil1),
                backgroundColor: "#00ff00",
                borderColor: "#00ff00",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              },
              {
                label: "Q2 - druhý kvartil",
                data: this.grafData2.map(i => i.Kvartil2),
                backgroundColor: "#FFFF33",
                borderColor: "#FFFF33",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              },
              {
                label: "Q3 - tretí kvartil",
                data: this.grafData2.map(i => i.Kvartil3),
                backgroundColor: "#FF9933",
                borderColor: "#FF9933",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              },
              {
                label:
                  "Q4 - štvrtý kvartil (maximálny stav hladiny podzemnej vody)",
                data: this.grafData2.map(i => i.Kvartil4),
                backgroundColor: "#FF3300",
                borderColor: "#FF3300",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              },
              {
                label: "Priemerná hodnota",
                data: this.grafData2.map(i => i.Priemer),
                backgroundColor: "#808080",
                borderColor: "#808080",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              },
              {
                label: "Trend",
                data: this.grafData2.map(i => i.Trend),
                backgroundColor: "#b7b5b5",
                borderColor: "#b7b5b5",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line"
              }
            ]
          }
          break
        default:
          break
      }
      return ret
    },
    grafOptions: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 1:
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: `Priebeh hĺbky hladiny a teploty podzemnej vody (${this.filterORange[0]} - ${this.filterORange[1]})`
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  //distribution: "series",
                  time: {
                    unit: "month"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "left",
                  id: "y-axis-hladina",
                  ticks: {
                    reverse: true
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "[m]"
                  }
                },
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "right",
                  id: "y-axis-teplota",
                  // grid line settings
                  scaleLabel: {
                    display: true,
                    labelString: "[°C]"
                  },
                  gridLines: {
                    drawOnChartArea: false // only want the grid lines for one axis to show up
                  }
                }
              ]
            }
          }
          break
        case 2:
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: `Základné štatistické ukazovatele vývoja hĺbky hladiny a teploty podzemnej vody - rok ${this.filterRok} oproti (${this.filterRORange[0]} - ${this.filterRORange[1]})`
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "month"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "left",
                  ticks: {
                    reverse: true
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "[m]"
                  }
                }
              ]
            }
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function(aIndex) {
      let url = "/r/chart/hpv" + aIndex
      url += "?bodID=" + Miscella.normalizeString(this.filterBodId)
      if (aIndex === 1) {
        url += "&rokOd=" + this.filterORange[0]
        url += "&rokDo=" + this.filterORange[1]
      }
      if (aIndex === 2) {
        url += "&rok=" + this.filterRok
        url += "&rokOd=" + this.filterRORange[0]
        url += "&rokDo=" + this.filterRORange[1]
      }
      return url
    },
    show: async function(aIndex) {
      let grafData = []
      try {
        console.log("ChartsHpv.vue, show " + aIndex)
        eval(`this.loading${aIndex} = true`)
        let response = await this.$axios.get(this.urlFetch(aIndex))
        if (response.status === 200) {
          if (response.data !== null) {
            grafData = response.data.data
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        switch (aIndex) {
          case 1:
            this.grafData1 = grafData
            break
          case 2:
            this.grafData2 = grafData
            break
          default:
            break
        }
        eval(`this.loading${aIndex} = false`)
      }
    }
  },
  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
  }
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
